import styled from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { rawColors } from "../../../design-system/tokens/colors";

/**
 * The Figma `Types` field group, shared by every row of the schedule forms:
 * a Caption-3 label above a control, 8px apart.
 *
 * Lives here rather than in any one component so the five schedule sections
 * and the modal that hosts them cannot drift apart — and so a molecule never
 * has to reach upward into an organism's styles for it.
 *
 * No heights are authored anywhere in this file. Figma stamps a measured
 * height on each of these frames (65 / 61 / 17) but those are outputs of the
 * content, not specs — the groups size themselves.
 */
export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[2]};
  width: 100%;
  min-width: 0;
`;

export const FieldLabel = styled.span`
  ${typographyMixin("caption", 3)}
  color: ${({ theme }) => theme.colors.text.secondary};
`;

/**
 * A row of equal-width controls (hour + timezone, "Schedule on" + "Schedule at").
 *
 * `flex: 1 1 0` + `min-width: 0` on the children, never `width: 50%` — the
 * split must hold regardless of how long an option label is.
 */
export const FieldRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${spacing[3]};
  width: 100%;
`;

export const FieldCol = styled.div`
  flex: 1 1 0;
  min-width: 0;
`;

/** Helper / validation caption rendered under a field. */
export const HelperText = styled.p<{ $error?: boolean }>`
  margin: 0;
  ${typographyMixin("caption", 4)}
  color: ${({ theme, $error }) =>
    $error ? rawColors.accent.red500 : theme.colors.text.secondary};
`;
